import React from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';
import useMobileDetect from '@/lib/hooks/useMobileDetect';

const FollowUsRightContent1 = ({
  qrCodeImageUrl,
  url,
  mediaName,
  h5QrCodeBottom,
}: {
  qrCodeImageUrl: string;
  url?: string;
  mediaName?: string[];
  h5QrCodeBottom?: boolean;
}) => {
  const t = useTranslations();
  const { isMobile } = useMobileDetect();

  const h5BgImage = h5QrCodeBottom ? '/images/home/followUsBgForH5_1.png' : '/images/home/followUsBgForH5.png';

  return (
    <div
      style={{
        backgroundImage: `url(${isMobile ? h5BgImage : '/images/home/followUsBg.png'})`,
        backgroundSize: '100% 100%',
      }}
      className={`flex h-full w-full flex-col bg-center bg-no-repeat ${isMobile && h5QrCodeBottom ? 'items-center justify-center pt-[2%]' : 'items-center justify-center'}`}
    >
      <Image
        src={qrCodeImageUrl}
        alt="xiaohongshu"
        width={300}
        height={300}
        className="aspect-square w-[37.4%] max-md:w-[35%]"
      />
      {url && (
        <Link
          href={url}
          target="_blank"
          className="mt-[4%] flex h-[10.4%] w-[37.4%] flex-row items-center justify-center bg-[#282849] text-[0.936vw] text-white max-md:text-[2.926vw]"
        >
          {t('Home.followUsRightText1')}{' '}
          <Image
            src={'/images/home/rightArrow_white.png'}
            width={38}
            height={18}
            className="ml-[2%] h-auto w-[6.3%]"
            alt="rightArrow"
          />
        </Link>
      )}
      {mediaName?.[0] && (
        <div className="mt-[2%] text-center text-[2.926vw] text-[#111111] md:hidden">{mediaName?.[0]}</div>
      )}
    </div>
  );
};

export default FollowUsRightContent1;
